var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _c("text-editor", {
        ref: "textEditor",
        model: {
          value: _vm.editorData,
          callback: function ($$v) {
            _vm.editorData = $$v
          },
          expression: "editorData",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }